import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const LanguageSelector = ({ variant = 'dropdown', showLabel = false }) => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    i18n.changeLanguage(newLanguage);
  };

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'it' : 'en';
    i18n.changeLanguage(newLanguage);
  };

  if (variant === 'toggle') {
    return (
      <Tooltip title={t('language.selectLanguage')}>
        <IconButton onClick={toggleLanguage} color="inherit">
          <LanguageIcon />
          <Typography variant="caption" sx={{ ml: 0.5 }}>
            {i18n.language?.toUpperCase() || 'EN'}
          </Typography>
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {showLabel && (
        <Typography variant="body2">
          {t('language.selectLanguage')}:
        </Typography>
      )}
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={i18n.language || 'en'}
          onChange={handleLanguageChange}
          displayEmpty
          sx={{ fontSize: '0.875rem' }}
        >
          <MenuItem value="en">
            <Box display="flex" alignItems="center" gap={1}>
              🇺🇸 {t('language.english')}
            </Box>
          </MenuItem>
          <MenuItem value="it">
            <Box display="flex" alignItems="center" gap={1}>
              🇮🇹 {t('language.italian')}
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;
